import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import useRemoveConfigAdministratorMutationHook from "@/hooks/mutations/useRemoveConfigAdministrator";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  selectedUserId: number;
};

const ConfirmRemoveAlert = (props: Props) => {

  const { open, onOpenChange, selectedUserId } = props;

  // Hooks
  const { t } = useTranslation(["common", "modals"]);

  // Mutations
  const {
    removeConfigAdministratorMutation,
  } = useRemoveConfigAdministratorMutationHook();

  const handleRemoveConfigAdmin = () => {
    if (!selectedUserId) return;

    removeConfigAdministratorMutation({ variables: { userId: selectedUserId } });
  };

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{t("modals:removeconfigadmin.title")}</AlertDialogTitle>
          <AlertDialogDescription>
            {t("modals:removeconfigadmin.description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>
            { t("buttons.cancel") }
          </AlertDialogCancel>
          <AlertDialogAction onClick={handleRemoveConfigAdmin}>
            { t("buttons.confirm") }
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmRemoveAlert;
